"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getClassName = exports["default"] = exports.StyleDot = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _excluded = ["className", "color", "hasMoreState", "isActive"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var styles = {
  "styleDot": "OxMAWn",
  "moreState": "y3AaIy",
  "active": "ljkvye"
};
var getClassName = exports.getClassName = function getClassName(_ref) {
  var className = _ref.className,
    hasMoreState = _ref.hasMoreState,
    isActive = _ref.isActive;
  return (0, _clsx["default"])(className, styles.styleDot, hasMoreState && styles.moreState, isActive && styles.active);
};
var StyleDot = exports.StyleDot = function StyleDot(_ref2) {
  var className = _ref2.className,
    color = _ref2.color,
    hasMoreState = _ref2.hasMoreState,
    isActive = _ref2.isActive,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/_react["default"].createElement("span", _extends({
    className: getClassName({
      className: className,
      hasMoreState: hasMoreState,
      isActive: isActive
    })
  }, props));
};
StyleDot.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes["default"].string,
  color: _propTypes["default"].string,
  hasMoreState: _propTypes["default"].bool,
  isActive: _propTypes["default"].bool
} : {};
var _default = exports["default"] = StyleDot;